/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import dynamic from "next/dynamic";
import animationData from "./unreal-dark-cosmos.json";

// `loading` is what makes Next emit a Suspense boundary for a dynamic import
// (hasSuspenseBoundary = !opts.ssr || !!opts.loading). Without it this bare
// dynamic() got a Fragment and relied on the boundary EDSProvider incidentally
// wrapped around every page, which MW-13210 removed.
const Lottie = dynamic(() => import("lottie-react"), { loading: () => null });

export const LottieLoading = (): React.JSX.Element | null => {
	return <Lottie animationData={animationData} />;
};
